import React from "react";


// import { SocketProvider } from "../contexts/SocketContext";
import { ChatProvider } from "../contexts/ChatContext";
import { UserProvider } from "../contexts/UserContext";
import ChatWindow from "./ChatWindow";
import "./ChatPage.css";
import "../common/common.css";
import "../groups/group.css";
import "../input/input.css";
import "../messages/messages.css";
import "../layout/sidebar.css";

function ChatPage() {
  return (
   
      <UserProvider>
        <ChatProvider>
          <ChatWindow />
        </ChatProvider>
      </UserProvider>
   
  );
}

export default ChatPage;
